<template>
    <div class="designerpage">

        <spitfire-designer-question-door-range v-if="range_panel_required"
                                         :fabricator="fabricator"
                                         v-model:target="door.attr.door_range"
                                         :ranges="ranges"
                                         :defaults="defaults()"
                                         title="Please select a Door Collection"
                                         :reference_on="reference_on"></spitfire-designer-question-door-range>

        <div>
            <wb-designer-question-select-door :fabricator="fabricator"
                                              :secured-by-design="door.attr.secured_by_design"
                                              :door-range="door.attr.door_range"
                                              :component-filter-box="true"
                                              v-model:target="door.attr.slab"></wb-designer-question-select-door>
        </div>

        <div>

            <spitfire-designer-question-select-frame-style v-if="!is_french" :fabricator="fabricator"
                                                           :is-firedoor="is_firedoorrange"
                                                           v-model:target="door.attr.frame_style"></spitfire-designer-question-select-frame-style>

            <wb-french-designer-question-select-frame-style v-if="is_french" :fabricator="fabricator"
                                                            :is-firedoor="is_firedoorrange"
                                                            v-model:target="door.attr.frame_style"
                                                            :frame-material="door.attr.frame_material"></wb-french-designer-question-select-frame-style>
        </div>

        <div class="designeroption">
            <designer-question-hinge-side v-if="!is_french" :fabricator="fabricator"
                                          v-model:target="door.attr.hinge_side"></designer-question-hinge-side>

            <designer-question-opening-direction :fabricator="fabricator"
                                                 v-model:target="door.attr.opening_direction"></designer-question-opening-direction>
        </div>

        <div v-show="door.attr.door_range != 86">
            <spitfire-designer-question-colour-range title="Colour Ranges"
                                                     :fabricator="fabricator"
                                                     v-model:target="door.attr.door_colour_range"
                                                     :slab="door.attr.slab"
                                                     :type-range="door.attr.door_range">
            </spitfire-designer-question-colour-range>
        </div>

        <div class="designeroption" data-designer-component-id="door_colour" v-show="door.attr.door_range == 48 || door.attr.door_range == 80 || door.attr.door_range == 91">

            <h3 v-if="door.attr.door_range == 48 || door.attr.door_range == 91">Choose Your Door Sash Colour
                <component-filter-box :search-filter.sync="door_colour_filter"></component-filter-box>
            </h3>
            <h3 v-else>Choose Your Door Sash & Frame Colour
                <component-filter-box :search-filter.sync="door_colour_filter"></component-filter-box>
            </h3>

            <div class="colourtabs">
                <ul>
                    <li><a href="#dc-tabs-1">External Colour</a></li>
                    <li><a href="#dc-tabs-2">Internal Colour</a></li>
                </ul>
                <div id="dc-tabs-1">
                    <spitfire-designer-question-door-colour-external :fabricator="fabricator" :slab="door.attr.slab"
                                                               :filter-search="door_colour_filter"
                                                               :colour-range="door.attr.door_colour_range"
                                                               :door-range="door.attr.door_range"
                                                               v-model:target="door.attr.external_colour"></spitfire-designer-question-door-colour-external>
                </div>
                <div id="dc-tabs-2">
                    <spitfire-designer-question-door-colour-internal :fabricator="fabricator" :slab="door.attr.slab"
                                                               :external-colour="door.attr.external_colour"
                                                               :filter-search="door_colour_filter"
                                                               :colour-range="door.attr.door_colour_range"
                                                               :door-range="door.attr.door_range"
                                                               v-model:target="door.attr.door_colour_internal"></spitfire-designer-question-door-colour-internal>
                </div>
            </div>
        </div>

        <div class="designeroption" data-designer-component-id="frame_colour" v-show="door.attr.door_range == 48 || door.attr.door_range == 91">
            <h3>Change frame colour if required
                <component-filter-box :search-filter.sync="frame_colour_filter"></component-filter-box>
            </h3>

            <div class="colourtabs">
                <ul>
                    <li><a href="#tabs-1">External Colour</a></li>
                    <li><a href="#tabs-2">Internal Colour</a></li>
                </ul>
                <div id="tabs-1">
                    <spitfire-designer-question-frame-colour-external :fabricator="fabricator"
                                                                :slab="door.attr.slab"
                                                                :profile="door.attr.profile"
                                                                :filter-search="frame_colour_filter"
                                                                      :colour-range="door.attr.door_colour_range"
                                                                v-model:target="door.attr.frame_colour_external"
                                                                :door-range="door.attr.door_range"></spitfire-designer-question-frame-colour-external>
                </div>
                <div id="tabs-2">
                    <spitfire-designer-question-frame-colour-internal :fabricator="fabricator"
                                                                :frame-colour-external="door.attr.frame_colour_external"
                                                                :slab="door.attr.slab"
                                                                :profile="door.attr.profile"
                                                                :filter-search="frame_colour_filter"
                                                                      :colour-range="door.attr.door_colour_range"
                                                                v-model:target="door.attr.frame_colour_internal"
                                                                :door-range="door.attr.door_range"></spitfire-designer-question-frame-colour-internal>
                </div>
            </div>
        </div>

        <div v-show="false">
            <wb-designer-question-door-glass-laminated :fabricator="fabricator"
                                                       title="Laminated Glass:"
                                                       :slab="door.attr.slab"
                                                       :frame-style="door.attr.frame_style"
                                                       :side-panels="door.attr.side_panels"
                                                       :secured-by-design="door.attr.secured_by_design"
                                                       :is-firedoor="is_firedoorrange"
                                                       v-model:target="door.attr.laminated_glass"></wb-designer-question-door-glass-laminated>
        </div>

        <div>
            <wb-designer-question-glass-design :fabricator="fabricator"
                                               v-model:target="door.attr.glass_design"
                                               :laminated-glass="door.attr.laminated_glass"
                                               :door-range="door.attr.door_range"
                                               :slab="door.attr.slab"
                                               :has_popup_info="!mdd || main_retail_mdd"
                                               popup_info_title_html="<span class='txt-positive'>Click here</span> to view satin glass with clear lines"
                                               popup_info_inner_html="<div class='align-center'><img src='https://tranquility-dev.s3.eu-west-2.amazonaws.com/fabricator_uploads/15/designer-info-popup-images/Satin%20Glass%20with%20Clear%20lines.jpg'></div>"
            ></wb-designer-question-glass-design>
        </div>

        <wb-designer-question-glass-backing-design :fabricator="fabricator"
                                                   v-model:target="door.attr.glass_backing_design"
                                                   :slab="door.attr.slab"
                                                   :glass-design="door.attr.glass_design"></wb-designer-question-glass-backing-design>

        <spitfire-designer-question-select-frame-sidepanels :fabricator="fabricator"
                                                      v-model:target="door.attr.side_panels"
                                                      :door-range="door.attr.door_range"
                                                      :frame-style="door.attr.frame_style"
                                                      :frame-profile="door.attr.profile"
                                                      :frame-material="door.attr.frame_material"
                                                      :laminated-glass="door.attr.laminated_glass"
                                                      :frame-colour-internal="door.attr.frame_colour_internal"
                                                      :frame-colour-external="door.attr.frame_colour_external"
                                                      :secured-by-design="door.attr.secured_by_design"
                                                      :slab="door.attr.slab"
                                                      :measurements.sync="door.attr.measurements"></spitfire-designer-question-select-frame-sidepanels>

        <div class="designeroption" v-if="is_french">
            <wb-designer-question-french-master :fabricator="fabricator"
                                                title="Select Your Master Door"
                                                v-model:target="door.attr.french_master"></wb-designer-question-french-master>
        </div>

        <div v-show="door.attr.door_range == 48 || door.attr.door_range == 91">
            <spitfire-designer-question-hardware-suite-selector :fabricator="fabricator"
                                                          v-model:target="door.attr.suite"
                                                          :door-range="door.attr.door_range"
                                                          :slab="door.attr.slab"
                                                          :secured-by-design="door.attr.secured_by_design"
                                                          :opening-direction="door.attr.opening_direction"
                                                          :profile="door.attr.profile"></spitfire-designer-question-hardware-suite-selector>
        </div>

      <div>

        <wb-designer-question-hardware-colour-with-suite :fabricator="fabricator"
                                                         v-model:target="door.attr.hardware_colour"
                                                         :sbd="door.attr.secured_by_design"
                                                         :slab="door.attr.slab"
                                                         :hardware-suite="door.attr.suite"
                                                         :door-range="door.attr.door_range"
                                                         :profile="door.attr.profile"
                                                         :opening-direction="door.attr.opening_direction"></wb-designer-question-hardware-colour-with-suite>
      </div>


        <div v-show="door.attr.door_range != 86">
            <wb-designer-question-hardware-handle-with-suite :fabricator="fabricator"
                                                             v-model:target="door.attr.hardware_handle"
                                                             :slab="door.attr.slab"
                                                             :secured-by-design="door.attr.secured_by_design"
                                                             :opening-direction="door.attr.opening_direction"
                                                             :hardware-colour="door.attr.hardware_colour"
                                                             :hardware-suite="door.attr.suite"
                                                             :door-range="door.attr.door_range"
                                                             title="Select Your External Handle"
                                                             :profile="door.attr.profile"></wb-designer-question-hardware-handle-with-suite>

            <wb-designer-question-hardware-handle-slave-with-suite v-if="is_french" :fabricator="fabricator"
                                                                   title="Select Your Slave Handle"
                                                                   v-model:target="door.attr.hardware_handle_slave"
                                                                   :hardware-handle="door.attr.hardware_handle"
                                                                   :slab="door.attr.slab"
                                                                   :secured-by-design="door.attr.secured_by_design"
                                                                   :opening-direction="door.attr.opening_direction"
                                                                   :hardware-colour="door.attr.hardware_colour"
                                                                   :hardware-suite="door.attr.suite"
                                                                   :door-range="door.attr.door_range"
                                                                   :profile="door.attr.profile"></wb-designer-question-hardware-handle-slave-with-suite>
        </div>

        <div v-show="door.attr.door_range == 48 || door.attr.door_range == 91">
            <wb-designer-question-hardware-handle-internal :fabricator="fabricator"
                                                           v-model:target="door.attr.hardware_handle_internal"
                                                           :slab="door.attr.slab"
                                                           :secured-by-design="door.attr.secured_by_design"
                                                           :opening-direction="door.attr.opening_direction"
                                                           :hardware-colour="door.attr.hardware_colour"
                                                           :door-range="door.attr.door_range"
                                                           :profile="door.attr.profile"
                                                           :handle-external="door.attr.hardware_handle"
                                                           :has_popup_info="!mdd || main_retail_mdd"
                                                           popup_info_title_html="<span class='txt-positive'>Click here</span> to view our silver plate handle"
                                                           popup_info_inner_html="<div class='align-center'><img src='https://tranquility-dev.s3.eu-west-2.amazonaws.com/fabricator_uploads/15/designer-info-popup-images/S-200%20Silver%20Plate%20Internal%20Lever%20Handle.jpg'></div>"
            ></wb-designer-question-hardware-handle-internal>

        </div>

            <wb-designer-question-hardware-escutcheon :fabricator="fabricator"
                                                      title="Select A Rosette"
                                                      v-model:target="door.attr.hardware_escutcheon"
                                                      :slab="door.attr.slab"
                                                      :secured-by-design="door.attr.secured_by_design"
                                                      :hardware-colour="door.attr.hardware_colour"
                                                      :hardware-handle="door.attr.hardware_handle"
                                                      :door-range="door.attr.door_range"
                                                      :profile="door.attr.profile"></wb-designer-question-hardware-escutcheon>

            <designer-question-hardware-escutcheon-position :fabricator="fabricator"
                                                            v-model:target="door.attr.hardware_escutcheon_pos"
                                                            :slab="door.attr.slab"
                                                            :frame-material="door.attr.frame_material"
                                                            :hardware-escutcheon="door.attr.hardware_escutcheon"></designer-question-hardware-escutcheon-position>

<!--        <div class="designeroption">-->
<!--            <h3>-->
<!--              Standard features with every door-->

<!--              <designer-question-popup-info-->
<!--                  v-if="!mdd || main_retail_mdd"-->
<!--                  popup_info_title_html="<span class='txt-positive'>Click here</span> to view our technical drawing and close up images"-->
<!--                  popup_info_inner_html="-->
<!--                  <div class='align-center mb-3'><img src='https://tranquility-dev.s3.eu-west-2.amazonaws.com/fabricator_uploads/15/designer-info-popup-images/S-200%20%28TLS%2090%29%20Technical%20Drawings%20Spitfire%20Doors%20%20Flat%20Frame%20ONLY%20Cross%20Section%20Sketch%202021.png'></div>-->
<!--                  <div class='align-center mb-3'><img src='https://tranquility-dev.s3.eu-west-2.amazonaws.com/fabricator_uploads/15/designer-info-popup-images/S-200+Flat+Frame+TLS+90+Flat.jpg'></div>-->
<!--                  <div class='align-center mb-3'><img src='https://tranquility-dev.s3.eu-west-2.amazonaws.com/fabricator_uploads/15/designer-info-popup-images/S-200+Silver+Hinge.jpg'></div>-->
<!--                  <div class='align-center'><img src='https://tranquility-dev.s3.eu-west-2.amazonaws.com/fabricator_uploads/15/designer-info-popup-images/S-200+Cylinder+guard+escutcheon.jpg'></div>"-->
<!--              ></designer-question-popup-info>-->

<!--            </h3>-->
<!--            <div class="stylesoption designer-question-tiled-layout">-->

<!--                <div class="tile active" v-if="door.attr.door_range == 86">-->
<!--                    <a href="#">-->
<!--                        <img src="/thumb/door-colour-1/207">-->
<!--                        <label>7016 Matt</label>-->
<!--                        <i class="fa fa-check" aria-hidden="true"></i>-->
<!--                    </a>-->
<!--                </div>-->

<!--                <div class="tile active" v-if="door.attr.door_range == 80 || door.attr.door_range == 86">-->
<!--                    <a href="#">-->
<!--                        <img src="/thumb/hardware/1609">-->
<!--                        <label>Internal Silver Lever Handle</label>-->
<!--                        <i class="fa fa-check" aria-hidden="true"></i>-->
<!--                    </a>-->
<!--                </div>-->

<!--                <div class="tile active" v-if="door.attr.door_range == 86">-->
<!--                    <a href="#">-->
<!--                        <img src="https://tranquility-dev.s3.eu-west-2.amazonaws.com/fabricator_uploads/15/spitfire-86-standard-bar.png">-->
<!--                        <label>External Bar Handle</label>-->
<!--                        <i class="fa fa-check" aria-hidden="true"></i>-->
<!--                    </a>-->
<!--                </div>-->

<!--                <div class="tile active" v-if="door.attr.door_range == 80">-->
<!--                    <a>-->
<!--                        <img src="/thumb/hardware/1634">-->
<!--                        <label>5 Point Lock</label>-->
<!--                        <i class="fa fa-check" aria-hidden="true"></i>-->
<!--                    </a>-->
<!--                </div>-->

<!--                <div class="tile active" v-if="door.attr.door_range == 80">-->
<!--                    <a>-->
<!--                        <img src="https://tranquility-dev.s3.eu-west-2.amazonaws.com/fabricator_uploads/15/spitfire_standard_features_TLS_50_Hinge.png">-->
<!--                        <label>3D Adjustable Flag Hinge - Colour matched</label>-->
<!--                        <i class="fa fa-check" aria-hidden="true"></i>-->
<!--                    </a>-->
<!--                </div>-->

<!--                <div class="tile active" v-if="door.attr.door_range == 86 || door.attr.door_range == 48 || door.attr.door_range == 91">-->
<!--                    <a>-->
<!--                        <img src="/thumb/hardware/1706">-->
<!--                        <label>2D two piece hinges - Silver (TLS 90)</label>-->
<!--                        <i class="fa fa-check" aria-hidden="true"></i>-->
<!--                    </a>-->
<!--                </div>-->

<!--                <div class="tile active" v-if="door.attr.door_range == 80">-->
<!--                    <a href="#">-->
<!--                        <img src="https://tranquility-dev.s3.eu-west-2.amazonaws.com/fabricator_uploads/15/spitfire_standard_features-S-100_TLS_50.png">-->
<!--                        <label>Standard Low Threshold (12mm of Clearance)</label>-->
<!--                        <i class="fa fa-check" aria-hidden="true"></i>-->
<!--                    </a>-->
<!--                </div>-->

<!--                <div class="tile active" v-if="door.attr.door_range == 86">-->
<!--                    <a href="#">-->
<!--                        <img src="https://tranquility-dev.s3.eu-west-2.amazonaws.com/fabricator_uploads/15/S-50_weathered_threshold.JPG">-->
<!--                        <label>Standard Weathered Threshold (20mm of Clearance)</label>-->
<!--                        <i class="fa fa-check" aria-hidden="true"></i>-->
<!--                    </a>-->
<!--                </div>-->

<!--                <div class="tile active" v-if="door.attr.door_range == 48 || door.attr.door_range == 91">-->
<!--                    <a href="#">-->
<!--                        <img src="/thumb/profile/14203">-->
<!--                        <label>Standard Low Threshold (12mm of Clearance)</label>-->
<!--                        <i class="fa fa-check" aria-hidden="true"></i>-->
<!--                    </a>-->
<!--                </div>-->

<!--                <div class="tile active" v-if="door.attr.door_range == 48 || door.attr.door_range == 91">-->
<!--                    <a>-->
<!--                        <img src="/thumb/hardware/1610">-->
<!--                        <label>Round Cylinder Escutcheon - Silver</label>-->
<!--                        <i class="fa fa-check" aria-hidden="true"></i>-->
<!--                    </a>-->
<!--                </div>-->

<!--                <div class="tile active" v-if="door.attr.door_range == 86">-->
<!--                    <a href="#">-->
<!--                        <img src="https://tranquility-dev.s3.eu-west-2.amazonaws.com/fabricator_uploads/15/spitfire-86-standard-lock.png">-->
<!--                        <label>Multi Point Lock</label>-->
<!--                        <i class="fa fa-check" aria-hidden="true"></i>-->
<!--                    </a>-->
<!--                </div>-->

<!--                <div class="tile active" v-if="door.attr.door_range != 86">-->
<!--                    <a href="#">-->
<!--                        <img src="/thumb/profile/17615">-->
<!--                        <label>Flat Outer Frame Profile</label>-->
<!--                        <i class="fa fa-check" aria-hidden="true"></i>-->
<!--                    </a>-->
<!--                </div>-->

<!--                &lt;!&ndash;flexbox hack&ndash;&gt;-->
<!--                <div class="tile-empty"></div><div class="tile-empty"></div><div class="tile-empty"></div><div class="tile-empty"></div><div class="tile-empty"></div>-->
<!--            </div>-->
<!--        </div>-->

        <div>
            <div v-show="door.attr.door_range != 86">
                <spitfire-designer-question-hardware-lock :fabricator="fabricator"
                                                 v-model:target="door.attr.hardware_lock"
                                                 :secured-by-design="door.attr.secured_by_design"
                                                 :hinge-side="door.attr.hinge_side"
                                                 :slab="door.attr.slab"
                                                 :frame-material="door.attr.frame_material"
                                                 :hardware-handle="door.attr.hardware_handle"
                                                 :opening_direction="door.attr.opening_direction"
                                                 :hardware-escutcheon="door.attr.hardware_escutcheon"
                                                 :door-range="door.attr.door_range"
                                                 :has_popup_info="!mdd || main_retail_mdd"
                                                 maintitle="Choose your lock"
                                                 title="Choose your lock"
                                                 :component_id="'hardware_lock'"
                                                 popup_info_title_html="<span class='txt-positive'>Click here</span> for more information"
                                                 popup_info_inner_html="<div class='align-center'><img src='https://tranquility-dev.s3.eu-west-2.amazonaws.com/fabricator_uploads/15/designer-info-popup-images/S-200+Locking+System+Breakdown.jpg'></div>"
                ></spitfire-designer-question-hardware-lock>
            </div>


            <designer-question-hardware-cylinder-tiled v-show="technical_should_show" :fabricator="fabricator"
                                                    title="Choose Your Cylinder"
                                                    :slab="door.attr.slab"
                                                    v-model:target="door.attr.hardware_cylinder"
                                                    :secured-by-design="door.attr.secured_by_design"
                                                    :hardware-lock="door.attr.hardware_lock"
                                                    :hardware-colour="door.attr.hardware_colour"
                                                    :opening_direction="door.attr.opening_direction"
                                                    :hardware-handle="door.attr.hardware_handle"
                                                    :door-range="door.attr.door_range"
                                                    :has_popup_info="!mdd || main_retail_mdd"
                                                    popup_info_title_html="<span class='txt-positive'>Click here</span> for more information"
                                                    popup_info_inner_html="
                                                    <div class='mb-3'><strong>Standard Cylinder</strong> - operates with a key from both sides.</div>
                                                    <div class=''><strong>Thumbturn Cylinder</strong> - internal thumb - turn barrel means door can be opened from inside without a key. Enables a quick exit in the event of fire or emergency, but please consider suitability if you have small children in the home.</div>"
            ></designer-question-hardware-cylinder-tiled>

            <designer-question-hardware-cylinder-guard v-show="technical_should_show" :fabricator="fabricator"
                                                       v-model:target="door.attr.hardware_cylinder_guard"
                                                       :secured-by-design="door.attr.secured_by_design"
                                                       :hardware-cylinder="door.attr.hardware_cylinder"
                                                       :hardware-colour="door.attr.hardware_colour"></designer-question-hardware-cylinder-guard>


        </div>

        <div>
            <wb-designer-question-hardware-letterbox :fabricator="fabricator"
                                                     v-model:target="door.attr.hardware_letterbox"
                                                     title="Add A Mailbox"
                                                     :slab="door.attr.slab"
                                                     :side-panels="door.attr.side_panels"
                                                     :frame-id="door.attr.frame_style.frame_id"
                                                     :hardware-handle="door.attr.hardware_handle"
                                                     :hardware-colour="door.attr.hardware_colour"
                                                     :door-range="door.attr.door_range"></wb-designer-question-hardware-letterbox>

            <designer-question-hardware-letterbox-cowl :fabricator="fabricator"
                                                       v-model:target="door.attr.hardware_letterbox_cowl"
                                                       :secured-by-design="door.attr.secured_by_design"
                                                       :hardware-letterplate="door.attr.hardware_letterbox"
                                                       :hardware-colour="door.attr.hardware_colour"></designer-question-hardware-letterbox-cowl>

            <designer-question-hardware-letterbox-position :fabricator="fabricator"
                                                           v-model:target="door.attr.hardware_letterbox_pos"
                                                           :slab="door.attr.slab"
                                                           :side-panels="door.attr.side_panels"
                                                           :frame-id="door.attr.frame_style.frame_id"
                                                           :frame-material="door.attr.frame_material"
                                                           :hardware-letterbox="door.attr.hardware_letterbox"></designer-question-hardware-letterbox-position>
        </div>
        <div v-show="door.attr.door_range != 86">
            <wb-designer-question-hardware-spy-hole :fabricator="fabricator"
                                                    title="Choose A Spyhole"
                                                    v-model:target="door.attr.hardware_spy_hole"
                                                    :slab="door.attr.slab"
                                                    :secured-by-design="door.attr.secured_by_design"
                                                    :glass-design="door.attr.glass_design"
                                                    :hardware-handle="door.attr.hardware_handle"
                                                    :hardware-knocker="door.attr.hardware_knocker"
                                                    :hardware-colour="door.attr.hardware_colour"
                                                    :door-range="door.attr.door_range"></wb-designer-question-hardware-spy-hole>

            <designer-question-hardware-spy-hole-position :fabricator="fabricator"
                                                          v-model:target="door.attr.hardware_spy_hole_pos"
                                                          :slab="door.attr.slab"
                                                          :frame-material="door.attr.frame_material"
                                                          :hardware-spy-hole="door.attr.hardware_spy_hole"></designer-question-hardware-spy-hole-position>
        </div>

            <wb-designer-question-hardware-hinge :fabricator="fabricator"
                                                 v-model:target="door.attr.hardware_hinge"
                                                 :slab="door.attr.slab"
                                                 :opening_direction="door.attr.opening_direction"
                                                 :secured-by-design="door.attr.secured_by_design"
                                                 :hardware-colour="door.attr.hardware_colour"
                                                 :hinge-side="door.attr.hinge_side"
                                                 :frame-material="door.attr.frame_material"
                                                 title="Select A Hinge (hinges are visible internally if your door is opening inwards)"
                                                 :door-range="door.attr.door_range"></wb-designer-question-hardware-hinge>

        <div v-show="door.attr.door_range != 86">

            <designer-question-opener v-show="technical_should_show" :fabricator="fabricator"
                                      v-model:target="door.attr.opener"
                                      :has_popup_info="!mdd || main_retail_mdd"
                                      popup_info_title_html="<span class='txt-positive'>Click here</span> for more information"
                                      popup_info_inner_html="<div class='mb-3'>
                                      <strong>Standard Latch</strong> - Functions like a standard composite door latch. This will “lock you out” if you have a pullbar on the outside and no key!
                                      </div>"
            ></designer-question-opener>

            <designer-question-hardware-hinge-bolts v-show="technical_should_show" :fabricator="fabricator"
                                                       v-model:target="door.attr.hardware_hinge_bolts"
                                                       :hardware-hinge="door.attr.hardware_hinge"
                                                       :secured-by-design="door.attr.secured_by_design"
                                                       :hardware-colour="door.attr.hardware_colour"></designer-question-hardware-hinge-bolts>
        </div>

        <div v-show="technical_should_show">
            <designer-question-restrictor :fabricator="fabricator"
                                          v-model:target="door.attr.restrictor"></designer-question-restrictor>


        </div>

        <div v-show="technical_should_show && door.attr.door_range != 86">
            <wb-designer-question-technical-profile :fabricator="fabricator"
                                                 :frame-colour-internal="door.attr.frame_colour_internal"
                                                 :frame-colour-external="door.attr.frame_colour_external"
                                                 :frame-material="door.attr.frame_material"
                                                 :secured-by-design="door.attr.secured_by_design"
                                                 :hardware-handle="door.attr.hardware_handle"
                                                 :hardware-escutcheon="door.attr.hardware_escutcheon"
                                                 :opening-direction="door.attr.opening_direction"
                                                 v-model:target="door.attr.profile"
                                                 :title="'Select a Frame Profile Shape'"
            ></wb-designer-question-technical-profile>

            <!--<spitfire-designer-question-trim-packs :fabricator="fabricator"-->
                                          <!--title="External Trim Packs"-->
                                          <!--:frame-profile="door.attr.profile"-->
                                          <!--:colour-range="door.attr.door_colour_range"-->
                                          <!--v-model:target="door.attr.trim_packs"-->
                                          <!--:has_popup_info="!mdd || main_retail_mdd"-->
                                          <!--popup_info_title_html="<span class='txt-positive'>Click here</span> for more information"-->
                                          <!--popup_info_inner_html="-->
                                      <!--<div>-->
                                        <!--The most elegant way to bridge the gap between external wall and your outer frame. Our flat aluminium trims are matched to your external frame colour and will set your installation apart-->
                                      <!--</div>"-->
            <!--&gt;</spitfire-designer-question-trim-packs>-->

            <designer-question-trim-packs-extended :fabricator="fabricator"
                                          title="Select Aluminium Trims (Flat Bars/Strips - 2400mm long, 2mm thick- colour matched to the frame)"
                                          :frame-profile="door.attr.profile"
                                          v-model:target="door.attr.trim_packs_extended"
                                          :frame-colour-external="door.attr.frame_colour_external"
                                          :frame-colour-internal="door.attr.frame_colour_internal"
            ></designer-question-trim-packs-extended>
        </div>

        <div v-show="technical_should_show">
            <spitfire-designer-question-addons :fabricator="fabricator"
                                      v-model:target="door.attr.addons"
                                      :frame-profile="door.attr.profile"
                                      :frame-colour-internal="door.attr.frame_colour_internal"
                                      :frame-colour-external="door.attr.frame_colour_external"
                                      :door-range="door.attr.door_range"
                                      :has_popup_info="!mdd || main_retail_mdd"
                                      popup_info_title_html="<span class='txt-positive'>Click here</span> for more information"
                                      popup_info_inner_html="
                                      <div>
If your door is larger than the maximum size we can make, you can use add-ons to make up the difference. For properties with a deep plaster line, you can use add-ons to get some extra frame width on hinge
jamb if you are worried about the hinged being buried in plaster                                      </div>"
            ></spitfire-designer-question-addons>
        </div>

        <div v-show="false">
            <spitfire-designer-question-technical-threshold :fabricator="fabricator"
                                                      title="Choose Your Threshold"
                                                   v-model:target="door.attr.threshold"
                                                   :opening-direction="door.attr.opening_direction"
                                                   :frame-profile="door.attr.profile"
                                                      :door-range="door.attr.door_range"></spitfire-designer-question-technical-threshold>

        </div>

        <div class="designeroption" v-show="technical_should_show">
            <h3>
              Select Any Required Cills or Threshold Packers
              <designer-question-popup-info
                  v-if="!mdd || main_retail_mdd"
                  popup_info_title_html="<span class='txt-positive'>Click here</span> for more information"
                  popup_info_inner_html="<div>
The cill sits underneath the door threshold and is designed there to help water drain away. If you have an existing door to rip out that has a cill, this should be removed and replaced.
All of our cills are 25mm high and 150mm from front to back (including the frame) and come with an optional 15mm packer, in case you want to pack the threshold/sill even up higher. You can also order a 15mm packer on it’s own
without a cill, if you need to raise the threshold slightly but do not require a cill. Please note if a cill with packer is selected, this means the total height at the door base will be 40mm and this is part of your overall height dimension
.</div>
<div class='align-center'><img src='https://tranquility-dev.s3.eu-west-2.amazonaws.com/fabricator_uploads/15/designer-info-popup-images/Spitfire+150+Cill+Detail+with+Endcaps+Dimensions+-+Technical+Drawing.png'></div>"
              ></designer-question-popup-info>
            </h3>
            <designer-question-technical-cill v-if="!is_firedoorrange" :fabricator="fabricator"
                                              v-model:target="door.attr.cill"
                                              :door-range="door.attr.door_range"
                                              :frame-colour-internal="door.attr.frame_colour_internal"
                                              :frame-colour-external="door.attr.frame_colour_external"
                                              :opening-direction="door.attr.opening_direction"
                                              :frame-profile="door.attr.profile"
                                              :component_id="'cill'"
            ></designer-question-technical-cill>

            <designer-question-technical-cill v-if="left_flag_sill && !is_firedoorrange" :fabricator="fabricator"
                                              v-model:target="door.attr.side_panels.left_flag_sill_id"
                                              :frame-colour-internal="door.attr.frame_colour_internal"
                                              :frame-colour-external="door.attr.frame_colour_external"
                                              :frame-profile="door.attr.profile"
                                              :title="'Left Sidepanel Flag'"
                                              :component_id="'left_flag_cill'"
            ></designer-question-technical-cill>

            <designer-question-technical-cill v-if="right_flag_sill && !is_firedoorrange" :fabricator="fabricator"
                                              v-model:target="door.attr.side_panels.right_flag_sill_id"
                                              :frame-colour-internal="door.attr.frame_colour_internal"
                                              :frame-colour-external="door.attr.frame_colour_external"
                                              :frame-profile="door.attr.profile"
                                              :threshold="door.attr.threshold"
                                              :title="'Right Sidepanel Flag'"
                                              :component_id="'right_flag_cill'"
            ></designer-question-technical-cill>
        </div>

        <div v-show="technical_should_show">
            <spitfire-designer-question-measurements title="Enter Your Required Measurements"
                                                    :fabricator="fabricator"
                                                    :slab="door.attr.slab"
                                                    :external-colour="door.attr.external_colour"
                                                    :internal-colour="door.attr.door_colour_internal"
                                                    :frame-profile="door.attr.profile"
                                                    :threshold="door.attr.threshold"
                                                    :frame-id="door.attr.frame_style.frame_id"
                                                    :side-panels="door.attr.side_panels"
                                                    :addons="door.attr.addons"
                                                    :cill="door.attr.cill"
                                                    :hardware-lock="door.attr.hardware_lock"
                                                    :hardware-hinge="door.attr.hardware_hinge"
                                                    :hardware-handle="door.attr.hardware_handle"
                                                    :hardware-knocker="door.attr.hardware_knocker"
                                                    :hardware-spy-hole="door.attr.hardware_spy_hole"
                                                    :hardware-escutcheon="door.attr.hardware_escutcheon"
                                                    :hardware-letterbox="door.attr.hardware_letterbox"
                                                    :hardware-letterbox-position="door.attr.hardware_letterbox_pos"
                                                    v-model:target="door.attr.measurements"
                                                    :door-range="door.attr.door_range"
                                                    :mdd="mdd"
                                                    :technical_should_show="technical_should_show"
            ></spitfire-designer-question-measurements>
        </div>

        <div class="designeroption" v-if="reference_on" data-designer-component-id="reference">
            <h3>Enter A Door Reference</h3>
            <div class="stylesoption">
                <div class="form-group">
                    <input dusk="door_reference" type="text" v-model="door.attr.reference" class="form-control">
                </div>
            </div>
        </div>
        <input v-else dusk="door_reference" type="hidden" v-model="door.attr.reference" class="form-control" value="Retail Door">

        <designer-question-notes v-model:target="door.attr.notes"></designer-question-notes>

      <designer-navigation
          v-if="show_navigation"
          :visible_designer_configurator_components="visible_designer_configurator_components"
          transition="designer-navigation"
      ></designer-navigation>

    </div>

</template>

<script type="text/ecmascript-6">
    import DoorConfigurator from "../DoorConfigurator.vue";

    export default {
        mixins: [
            DoorConfigurator
        ],
        props:{
            door_colour_filter: {
                default() {
                    return '';
                }
            },
            frame_colour_filter: {
                default() {
                    return '';
                }
            },
        },
        computed: {
            is_firedoorrange(){
                //return this.door.attr.door_range === 22;
            },
            is_french(){
                return this.door_type === 'french';
            },
        },
        methods: {
          defaults() {
            var measurements = {
              "overall_width": null,
              "overall_height": null,
              "left_width": null,
              "right_width": null,
              "top_box_drop": null
            };

            if(!this.mdd) {
              measurements = {
                "overall_width": this.door_type === 'french' ? 1800 : 1000,
                "overall_height": 2100,
                "left_width": 500,
                "right_width": 500,
                "top_box_drop": 500
              };
            }

            return {
              48: {
                "attr": {
                  "fabricator": 15,
                  "door_range": 48,
                  "hardware_suite": 71,
                  "frame_colour_external": 207,
                  "external_colour": 207,
                  "door_colour_internal": 207,
                  "frame_colour_internal": 207,
                  "door_colour_range": 5,
                  "frame_material": 5,
                  "glass_design": 1,
                  "hardware_colour": 15,
                  "hardware_handle": 1604,
                  "hardware_hinge": 1706,
                  "hinge_side": 1,
                  "opening_direction": 1,
                  "slab": 913,
                  "frame_style": {"frame_id": 57, "checkedPanels": []},
                  "laminated_glass": 1,
                  "hardware_lock": 1634,
                  "hardware_cylinder": 1614,
                  "hardware_letterbox": 318,
                  "hardware_escutcheon": 1610,
                  "profile": 17615,
                  "threshold": 14203,
                  "side_panels": {
                    "left": 36,
                    "right": 36,
                    "left_composite_id": null,
                    "right_composite_id": null,
                    "top_panel_glass_id": 9,
                    "left_composite_glass_id": null,
                    "right_composite_glass_id": null,
                    "left_panel_glass_id": 9,
                    "right_panel_glass_id": 9,
                    "side_glass_text": {"text": "", "position": null}
                  },
                  "numerals": [null, null, null, null],
                    "addons": {
                        "left": {},
                        "right": {},
                        "top": {},
                        "bottom": {},
                    },
                  "drainage": null,
                  "notes": "",
                  "measurements": measurements,
                  "closer": 598,
                  "secured_by_design": 1,
                  "hardware_spy_hole": 316,
                  "hardware_knocker": 315,
                  "cill": 149,
                  "opener": 1637,
                  "hardware_handle_internal": 1609,
                  "hardware_escutcheon_pos": 27246,
                  "trim_packs_extended": {"internal": {}, "external": {}},
                   "suite": 71
                }
              },
              80: {
                "attr": {
                  "fabricator": 15,
                  "door_range": 80,
                  "hardware_suite": 5,
                  "frame_colour_external": 207,
                  "external_colour": 207,
                  "door_colour_internal": 207,
                  "frame_colour_internal": 207,
                  "door_colour_range": 5,
                  "frame_material": 5,
                  "glass_design": 1,
                  "hardware_colour": 15,
                  "hardware_handle": 1604,
                  "hardware_hinge": 1706,
                  "hinge_side": 1,
                  "opening_direction": 1,
                  "slab": 913,
                  "frame_style": {"frame_id": 57, "checkedPanels": []},
                  "laminated_glass": 1,
                  "hardware_lock": 1634,
                  "hardware_cylinder": 1614,
                  "hardware_letterbox": 318,
                  "hardware_escutcheon": 1610,
                  "profile": 17615,
                  "threshold": 144168,
                  "side_panels": {
                    "left": 36,
                    "right": 36,
                    "left_composite_id": null,
                    "right_composite_id": null,
                    "top_panel_glass_id": 9,
                    "left_composite_glass_id": null,
                    "right_composite_glass_id": null,
                    "left_panel_glass_id": 9,
                    "right_panel_glass_id": 9,
                    "side_glass_text": {"text": "", "position": null}
                  },
                  "numerals": [null, null, null, null],
                    "addons": {
                        "left": {},
                        "right": {},
                        "top": {},
                        "bottom": {},
                    },
                  "drainage": null,
                  "notes": "",
                  "measurements": {
                    "overall_width": 1000,
                    "overall_height": 2100,
                    "left_width": 500,
                    "right_width": 500,
                    "top_box_drop": 500
                  },
                  "closer": 598,
                  "secured_by_design": 1,
                  "hardware_spy_hole": 316,
                  "hardware_knocker": 315,
                  "cill": 149,
                  "opener": 1637,
                  "hardware_handle_internal": 1609,
                  "hardware_escutcheon_pos": 27246,
                  "suite": 71,
                    "trim_packs_extended": {"internal": {}, "external": {}},
                }
              },
              86: {
                "attr": {
                  "fabricator": 15,
                  "door_range": 86,
                  "hardware_suite": 5,
                  "frame_colour_external": 207,
                  "external_colour": 207,
                  "door_colour_internal": 207,
                  "frame_colour_internal": 207,
                  "door_colour_range": 5,
                  "frame_material": 5,
                  "glass_design": 599,
                  "hardware_colour": 15,
                  "hardware_handle": 2215,
                  "hardware_hinge": 1706,
                  "hinge_side": 1,
                  "opening_direction": 1,
                  "slab": 1134,
                  "frame_style": {"frame_id": 57, "checkedPanels": []},
                  "laminated_glass": 1,
                  "hardware_lock": 2216,
                  "hardware_cylinder": 1614,
                  "hardware_letterbox": 318,
                  "hardware_escutcheon": 1610,
                  "profile": 17620,
                  "threshold": 145511,
                  "side_panels": {
                    "left": 36,
                    "right": 36,
                    "left_composite_id": null,
                    "right_composite_id": null,
                    "top_panel_glass_id": 9,
                    "left_composite_glass_id": null,
                    "right_composite_glass_id": null,
                    "left_panel_glass_id": 9,
                    "right_panel_glass_id": 9,
                    "side_glass_text": {"text": "", "position": null}
                  },
                  "numerals": [null, null, null, null],
                    "addons": {
                        "left": {},
                        "right": {},
                        "top": {},
                        "bottom": {},
                    },
                  "drainage": null,
                  "notes": "",
                  "measurements": {"overall_width": 1000, "overall_height": 2100, "left_width": 500, "right_width": 500, "top_box_drop": 500},
                  "closer": 598,
                  "secured_by_design": 1,
                  "hardware_spy_hole": 316,
                  "hardware_knocker": 315,
                  "cill": 149,
                  "opener": 1637,
                  "hardware_handle_internal": 1609,
                  "hardware_escutcheon_pos": 321662,
                  "suite": 71,
                    "trim_packs_extended": {"internal": {}, "external": {}},
                }
              },
              91: {
                "attr": {
                  "fabricator":15,
                  "door_range":91,
                  "suite":71,
                  "frame_colour_external":207,
                  "external_colour":207,
                  "door_colour_internal":207,
                  "frame_colour_internal":207,
                  "door_colour_range":5,
                  "frame_material":5,
                  "glass_design":1,
                  "hardware_colour":15,
                  "hardware_handle":1604,
                  "hardware_handle_slave":2240,
                  "hardware_hinge":1706,
                  "hinge_side":1,
                  "opening_direction":1,
                  "slab":917,
                  "frame_style":{
                    "frame_id":57,
                    "checkedPanels":[]
                  },
                  "laminated_glass":1,
                  "hardware_lock":1634,
                  "hardware_cylinder":1614,
                  "hardware_letterbox":318,
                  "hardware_escutcheon":1610,
                  "profile":17615,
                  "threshold":14203,
                  "side_panels":{
                    "left":36,
                    "right":36,
                    "left_composite_id":null,
                    "right_composite_id":null,
                    "top_panel_glass_id":9,
                    "left_composite_glass_id":null,
                    "right_composite_glass_id":null,
                    "left_panel_glass_id":9,
                    "right_panel_glass_id":9,
                    "side_glass_text":{
                      "text":"",
                      "position":null
                    }
                  },
                  "numerals":[null, null, null, null],
                    "addons": {
                        "left": {},
                        "right": {},
                        "top": {},
                        "bottom": {},
                    },
                  "drainage":null,
                  "notes":"",
                  "measurements": measurements,
                  "closer":598,
                  "secured_by_design":1,
                  "hardware_spy_hole":316,
                  "hardware_knocker":315,
                  "cill":149,
                  "opener":1637,
                  "hardware_handle_internal":1609,
                  "hardware_escutcheon_pos":27250,
                  "french_master":1,
                    "trim_packs_extended": {"internal": {}, "external": {}},
                }
              }
            };
          },
        }
    }
</script>
